<template>
  <el-input
      ref="elInput"
      v-bind="$attrs"
      v-on="$listeners"
      type="textarea"
      :placeholder="placeholder"
  ></el-input>
</template>

<script>
  export default {
    name: "gj-textarea",
    props: {
      placeholder: {
        type: String,
        default: '请输入内容'
      },
      styles: {
        type: Object,
        default() {
          return {};
        }
      }
    },
    watch: {
      styles(val) {
        this.setStyles(val);
      }
    },
    mounted() {
      this.setStyles(this.styles);
    },
    methods: {
      setStyles(styles) {
        for (let key in styles) {
          this.$refs.elInput.$refs.textarea.style[key] = styles[key];
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-textarea__inner {
    font-weight: 400;
    font-size: 12px;
    // font-family: Arial;
    &::-webkit-input-placeholder{
      color:#999999;
    }
  }
</style>
